import { initializeApp, getApps, getApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyDt9CRLOuVZDIpXPL4PiaRLZbfvepIPBOk",
  authDomain: "klarway-sis-dev.firebaseapp.com",
  projectId: "klarway-sis-dev",
  storageBucket: "klarway-sis-dev.firebasestorage.app",
  messagingSenderId: "159670599259",
  appId: "1:159670599259:web:b24a742a31509d2a38897e",
  measurementId: "G-RX5K9B1EHD"
};

const missingKeys = Object.entries(firebaseConfig)
  .filter(([, value]) => !value)
  .map(([key]) => key);

if (missingKeys.length && process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line no-console
  console.warn(`Firebase config is missing the following keys: ${missingKeys.join(', ')}`);
}

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const database = getDatabase(app);

export default app;